import { render, staticRenderFns } from "./manageCompany.vue?vue&type=template&id=2e967d68"
import script from "./manageCompany.vue?vue&type=script&lang=js"
export * from "./manageCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports